<!-- Navbar -->
<nav class="bg-base-200 shadow-md ">
  <div class="container flex justify-between items-center text-base-content">
    <!-- Logo -->
    <a routerLink="/" class=" cursor-pointer">
      <!-- <img src="/logos/Blockbuster-darkMode.png" alt="Logo" class="w-16 hidden dark:inline aspect-square" />
      <img src="/logos/Blockbuster-lightMode.png" alt="Logo" class="w-16 dark:hidden aspect-square" /> -->
       <div class="flex gap-2 items-center">
        <img src="/logos/Blockbuster-darkMode-Logo.png" alt="Logo" class="w-14 hidden dark:inline aspect-square" />
        <img src="/logos/Blockbuster-darkMode-Char.png" alt="Logo" class="w-50 h-10 hidden  dark:hidden dark:md:inline  " />
       </div>
       <div class="flex gap-2 items-center">
           <img src="/logos/Blockbuster-lightMode-Logo.png" alt="Logo" class="w-14 dark:hidden aspect-square" />
          <img src="/logos/Blockbuster-lightMode-Char.png" alt="Logo" class="w-50 h-10 dark:hidden hidden md:inline " />
       </div>
    </a>

    <!-- Tabs (Large Screens) -->
   <div class="hidden lg:flex space-x-6 items-center">
  <a 
    routerLink="/home" 
    routerLinkActive="active" 
    #rla="routerLinkActive" 
    [class.activeLink]="rla.isActive"
    [routerLinkActiveOptions]="{ exact: true }"
    class="hover:text-primary transition-all duration-500 relative after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-full after:h-[2px] after:scale-x-0 hover:after:scale-x-100 after:origin-center after:bg-primary after:transition-transform pb-1 font-medium"
  >Home</a>

  <a 
    routerLink="/movies" 
    routerLinkActive="active" 
    #rlaMovies="routerLinkActive" 
    [class.activeLink]="rlaMovies.isActive"
    class="hover:text-primary transition-all duration-500 relative after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-full after:h-[2px] after:scale-x-0 hover:after:scale-x-100 after:origin-center after:bg-primary after:transition-transform pb-1 font-medium"
  >Movies</a>

  <a 
    routerLink="/series" 
    routerLinkActive="active" 
    #rlaSeries="routerLinkActive" 
    [class.activeLink]="rlaSeries.isActive"
    class="hover:text-primary transition-all duration-500 relative after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-full after:h-[2px] after:scale-x-0 hover:after:scale-x-100 after:origin-center after:bg-primary after:transition-transform pb-1 font-medium"
  >Series</a>

  <a 
    routerLink="/about" 
    routerLinkActive="active" 
    #rlaAbout="routerLinkActive" 
    [class.activeLink]="rlaAbout.isActive"
    [routerLinkActiveOptions]="{ exact: true }"
    class="hover:text-primary transition-all duration-500 relative after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-full after:h-[2px] after:scale-x-0 hover:after:scale-x-100 after:origin-center after:bg-primary after:transition-transform pb-1 font-medium"
  >About Us</a>

  <a 
    routerLink="/contact-us" 
    routerLinkActive="active" 
    #rlaContact="routerLinkActive" 
    [class.activeLink]="rlaContact.isActive"
    [routerLinkActiveOptions]="{ exact: true }"
    class="hover:text-primary transition-all duration-500 relative after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-full after:h-[2px] after:scale-x-0 hover:after:scale-x-100 after:origin-center after:bg-primary after:transition-transform pb-1 font-medium"
  >Contact Us</a>
</div>

    <div class="actions hidden lg:flex gap-4 items-center">
      <!-- Icons & Button -->
      <app-theme-button />
      <app-cart />
      @if (!authService.isLoggedIn()) {
      <a routerLink="register"
        class="bg-primary btn btn-active hover:shadow-[0px_0px_5px_var(--color-primary)] transition-all">
        Register
      </a>
      }@else {
      <app-user-avatar />
      }
    </div>

    <!-- Burger Icon (Mobile) -->
    <div class="lg:hidden">
      <button (click)="toggleMenu()">
        <i class="fas fa-bars text-3xl text-(--color-primary)"></i>
      </button>
    </div>
  </div>

  <!-- Sidebar -->
  <div
    class="fixed top-0 left-0 h-full w-64 bg-base-200 text-base-content shadow-lg z-50 transform transition-color duration-300 md:hidden"
    [class.-translate-x-full]="!menuOpen" [class.translate-x-0]="menuOpen">
    <div class="flex justify-between items-center p-4 border-b border-(--color-primary)">
      <h2 class="text-xl font-bold">BlockBuster</h2>
      <button (click)="toggleMenu()">
        <i class="fas fa-times text-2xl"></i>
      </button>
    </div>
    <ul class="p-4 space-y-6 pt-8">
      <li><a routerLink="/home" 
            routerLinkActive="active" 
            #rla="routerLinkActive" 
            [class.activeLink]="rla.isActive"
            [routerLinkActiveOptions]="{ exact: true }"
          class=" font-medium hover:text-primary  transition-all relative after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-full after:h-[2px] after:scale-x-0 hover:after:scale-x-100 after:origin-left after:bg-primary after:transition-transform pb-1">Home</a>
      </li>
      <li><a  routerLink="/movies" 
    routerLinkActive="active" 
    #rlaMovies="routerLinkActive" 
    [class.activeLink]="rlaMovies.isActive"
          class="font-medium hover:text-primary  transition-all relative after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-full after:h-[2px] after:scale-x-0 hover:after:scale-x-100 after:origin-left after:bg-primary after:transition-transform pb-1">Movies
        </a></li>
      <li><a routerLink="/series" 
    routerLinkActive="active" 
    #rlaSeries="routerLinkActive" 
    [class.activeLink]="rlaSeries.isActive"
          class="font-medium hover:text-primary  transition-all relative after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-full after:h-[2px] after:scale-x-0 hover:after:scale-x-100 after:origin-left after:bg-primary after:transition-transform pb-1">Series</a>
      </li>
      <li><a routerLink="/about" 
    routerLinkActive="active" 
    #rlaAbout="routerLinkActive" 
    [class.activeLink]="rlaAbout.isActive"
    [routerLinkActiveOptions]="{ exact: true }"
          class="font-medium hover:text-primary  transition-all relative after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-full after:h-[2px] after:scale-x-0 hover:after:scale-x-100 after:origin-left after:bg-primary after:transition-transform pb-1">About
          Us</a></li>
      <li><a  routerLink="/contact-us" 
    routerLinkActive="active" 
    #rlaContact="routerLinkActive" 
    [class.activeLink]="rlaContact.isActive"
    [routerLinkActiveOptions]="{ exact: true }"
          class="font-medium hover:text-primary  transition-all relative after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-full after:h-[2px] after:scale-x-0 hover:after:scale-x-100 after:origin-left after:bg-primary after:transition-transform pb-1">Contact
          Us</a></li>
      <li class="flex space-x-5 justify-between">
        <app-theme-button />
        <app-cart />
      </li>
      <li class="flex justify-center">
        @if (!authService.isLoggedIn()) {
        <a routerLink="register"
          class="w-full bg-primary btn btn-active hover:shadow-[0px_0px_5px_var(--color-primary)] transition-all">
          Register
        </a>
        }@else {
        <app-user-avatar class="w-full" />
        }
      </li>
    </ul>
  </div>
</nav>